module.exports = __webpack_public_path__ + "img/Dekontaminationsgruppe_Personen.b6e7cba1.svg";